module.exports = "<div class=\"advanced\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/advanced.component.html
// module id = 1509
// module chunks = 2